/// <reference path="../../node_modules/@1js/office-online-strings/en-US/transcription-strings.d.ts" />

import * as React from 'react'
import { AppAuthenticationProviderContext } from './context';
import { Router, Route } from 'react-router-dom';
import { createMemoryHistory } from 'history';
import { routes } from './routes';
import { InitializeApp } from './Boot';
import { IAuthenticationProvider } from '../backend/interfaces/IAuthenticationProvider';
import { HostAppUtil }  from '../backend/office-js/HostAppUtil';
import { HOST_PLATFORM_WIN32 } from '../AppConstants';
import { AppLayoutSettings } from './common/styles/common.styles';

export const App: React.FunctionComponent = (): JSX.Element => {
  const [ isAppLoaded, setIsAppLoaded] = React.useState(false);
  const [ authProvider, setAuthProvider ] = React.useState<IAuthenticationProvider|null>(null);

  const [ history, ] = React.useState(createMemoryHistory({
    initialEntries:routes.map(route => route.pathname),
    initialIndex: 1
  }));

  React.useEffect(() => {
    Office.onReady(() => {
      // On OfficeJs ready call, seting background color of transcription pane to dark grey if platform is Win32 i.e. Win32 office app's background color.
      // In future for dark mode support in win32, we can update the background color value of pane appropriately.
      if (HostAppUtil.GetHostAppPlatform() == HOST_PLATFORM_WIN32) {
        window.document.getElementById("container")?.style.setProperty("background", AppLayoutSettings.getAppColorContainer().officeDesktopBackgroundColor.value)
      }
      InitializeApp(history, setAuthProvider, setIsAppLoaded);
    });
  },
    // Passing an empty array ensures that the effect only runs once
    []
  );

  // Show shimmer while app is not initialized.
  if (!isAppLoaded) {
    // Setting the shimmer to visible so that user keep seeing the shimmer while our boot code is executing.
    window.document.getElementById("shimmer")?.style.setProperty("visibility", "visible");
    return (<div />);
  }
  // Now that our App is loaded, we can remove shimmer.
  window.document.getElementById("shimmer")?.style.setProperty("display", "none");

  return (
    <AppAuthenticationProviderContext.Provider value={authProvider}>
      <Router
        history={history}
      >
        { routes.map(route =>
          <Route
            key={route.name}
            path={route.pathname}
            component={route.component}
          />
        )}
      </Router>
    </AppAuthenticationProviderContext.Provider>
  );
};